import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import InnerLayout from "../../layouts/inner-layout";
import SelectField from "../../forms/select-field";
import AddButton from "../../buttons/button";
import SaveIcon from "../../../assets/icons/save-icon";
import { useDispatch } from "react-redux";
import { GripVertical } from "lucide-react";
import {
  DocListAction,
  RolesListAction,
} from "../../../redux/actions/general-action";
import {
  userMOdPermissionsAction,
  userModCreateAction,
} from "../../../redux/actions/user-action";
import { values } from "lodash";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import { formatString } from "../../helper-components/helper-function";
import ChevronDown, {
  ChevronRight,
} from "../../../assets/icons/chevron-down-right";
import LoadingSpinner from "../../helper-components/loading-spinner";

const DraggableRow = ({
  column,
  index,
  parentIndex = null, // parent row index for subtable rows
  values,
  setFieldValue,
  tabletype,
  dragType,
}) => {
  const [expandedRows, setExpandedRows] = useState([]);
  const [, ref] = useDrag({ type: dragType, item: { index, parentIndex } });
  const [, drop] = useDrop({
    accept: dragType,
    hover: (draggedItem) => {
      if (
        draggedItem.index === index &&
        draggedItem.parentIndex === parentIndex
      ) {
        return; // no change
      }

      if (tabletype !== "sub") {
        // Reorder top-level customization array
        const updatedColumns = [...values.customization];
        const [moved] = updatedColumns.splice(draggedItem.index, 1);
        updatedColumns.splice(index, 0, moved);
        setFieldValue("customization", updatedColumns);
        draggedItem.index = index;
        draggedItem.parentIndex = null;
      } else {
        // Reorder inside childrenHeading of the parent row
        const updatedColumns = [...values.customization];
        const children = updatedColumns[parentIndex].childrenHeading || [];
        const updatedChildren = [...children];
        const [moved] = updatedChildren.splice(draggedItem.index, 1);
        updatedChildren.splice(index, 0, moved);
        updatedColumns[parentIndex].childrenHeading = updatedChildren;
        setFieldValue("customization", updatedColumns);

        draggedItem.index = index;
        draggedItem.parentIndex = parentIndex;
      }
    },
  });

  // console.log(column, "dfsfsfsdfsdfsf");
  const basePath =
    tabletype === "top"
      ? `customization[${index}]`
      : `customization[${parentIndex}].childrenHeading[${index}]`;
  const handleChange = (field, e, isNumber = false) => {
    const val = isNumber ? Number(e.target.value) : e.target.value;
    setFieldValue(`${basePath}.${field}`, val);
  };

  // Toggle enabled flag
  const toggleEnabled = () => {
    setFieldValue(`${basePath}.enabled`, !column.enabled);
  };
  const isExpanded = expandedRows.includes(index);

  const toggleRow = () => {
    if (isExpanded) {
      setExpandedRows(expandedRows.filter((i) => i !== index));
    } else {
      setExpandedRows([...expandedRows, index]);
    }
  };
  return (
    <>
      <tr
        className={`hover:bg-[var(--list-table-row-hover-bg)] bg-[var(--list-table-row-bg)] h-[50px]`}
        ref={(node) => ref(drop(node))}
      >
        <td
          className={`border-b min-w-[6rem] border-[var(--list-table-border-color)]  px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap cursor-move`}
        >
          <div className="flex">
            {column.childrenHeading && column.childrenHeading.length > 0 && (
              <>
                {column.childrenHeading &&
                  column.childrenHeading.length > 0 && (
                    <button type="button" onClick={toggleRow} className="">
                      {isExpanded ? (
                        <ChevronDown fill="black" />
                      ) : (
                        <ChevronRight fill="black" />
                      )}
                    </button>
                  )}
              </>
            )}
            {tabletype === "sub" && <div className="min-w-[3rem]"></div>}
            <GripVertical
              size={20}
              color="var(--create-table-row-placeholder-color)"
            />
          </div>
        </td>
        {/* Label Input */}
        <td
          className={`border-b border-[var(--list-table-border-color)] px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap`}
        >
          <input
            disabled={true}
            type="text"
            value={column.value}
            onChange={(e) => handleChange("value", e)}
            className="w-[15rem] px-2 py-[8px] border border-[var(--list-table-border-color)] rounded-sm bg-white text-sm text-[var(--list-table-row-fg-color)] border-radius"
          />
        </td>
        <td
          className={`border-b border-[var(--list-table-border-color)] px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap`}
        >
          <input
            type="text"
            value={column.label}
            onChange={(e) => handleChange("label", e)}
            className="w-[15rem] px-2 py-[8px] border border-[var(--list-table-border-color)] rounded-sm bg-white text-sm text-[var(--list-table-row-fg-color)] border-radius"
          />
        </td>
        {/* minWidth Input */}
        <td
          className={`border-b border-[var(--list-table-border-color)] px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap`}
        >
          <input
            type="number"
            value={column.minWidth}
            onChange={(e) => handleChange("minWidth", e, true)}
            className="border-radius w-[15rem] px-2 py-[8px] border border-[var(--list-table-border-color)] rounded-sm bg-white text-sm text-[var(--list-table-row-fg-color)]"
          />
        </td>
        {/* Type Select */}
        <td
          className={`border-b border-[var(--list-table-border-color)] px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap`}
        >
          <select
            value={column.type}
            onChange={(e) => handleChange("type", e)}
            className="border-radius w-[15rem] px-2 py-[8px] border border-[var(--list-table-border-color)] rounded-sm bg-white text-sm text-[var(--list-table-row-fg-color)]"
          >
            <option value="text">Text</option>
            <option value="number">Number</option>
            <option value="date">Date</option>
            <option value="boolean">Boolean</option>
          </select>
        </td>
        {/* Alignment Select */}
        <td
          className={`border-b border-[var(--list-table-border-color)] px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap`}
        >
          <select
            value={column.alignment}
            onChange={(e) => handleChange("alignment", e)}
            className="border-radius w-[15rem] px-2 py-[8px] border border-[var(--list-table-border-color)] rounded-sm bg-white text-sm text-[var(--list-table-row-fg-color)]"
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </td>
        {/* Toggle Switch */}
        <td
          className={`border-b border-[var(--list-table-border-color)] px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap`}
        >
          <button
            type="button"
            role="switch"
            aria-checked={column.enabled}
            onClick={toggleEnabled}
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 ease-in-out ${
              column.enabled ? "bg-primary" : "bg-[var(--toggle-switch-off-bg)]"
            }`}
            aria-label="Toggle Switch"
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-[#ffffff] transition-transform duration-200 ease-in-out ${
                column.enabled ? "translate-x-4" : "translate-x-1"
              }`}
            />
          </button>
        </td>
      </tr>
      {column.childrenHeading && column.childrenHeading.length > 0 && (
        <>
          {" "}
          {isExpanded &&
            column?.childrenHeading?.map((childColumn, childIndex) => (
              <DraggableRow
                key={childColumn.id}
                column={childColumn}
                index={childIndex}
                parentIndex={index} // important: pass parent's index!
                values={values}
                setFieldValue={setFieldValue}
                tabletype="sub"
                dragType="COLUMN_SUB"
              />
            ))}
        </>
      )}
    </>
  );
};

const ColumnConfigForm = () => {
  const [loading, setLoading] = useState(false);

  const [initialValues, setInitialValues] = useState({
    role_id: "",
    document_id: "",
    customization: [],
    defaultCustomization: [],
  });
  const [rolesList, setRolesList] = useState([]);
  const [docList, setDocList] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(RolesListAction(onSuccessRoles, onErrorRoles));
    dispatch(DocListAction(onSuccessDoc, onErrorDoc));
  }, []);
  const onSuccessRoles = (data) => {
    setRolesList(
      data?.data?.map((item) => ({
        label: item?.role_name,
        value: item?.role_id,
      }))
    );
  };
  const onErrorRoles = (data) => {};
  const onSuccessDoc = (data) => {
    setDocList(
      data?.data?.map((item) => ({
        label: formatString(item?.document_type_name),
        value: item?.document_id,
      }))
    );
  };
  const onErrorDoc = (data) => {};

  function fetchPermissions(role_id, document_id, setValues) {
    setLoading(true);
    dispatch(
      userMOdPermissionsAction(
        { role_id, document_id },
        (data) => {
          setLoading(false);

          setValues((prevValues) => ({
            ...prevValues,
            customization: data?.data?.customziationValues?.[0]?.customization,
            defaultCustomization: data?.data?.defaultValues?.[0]?.customization,
          }));
        },
        (data) => {
          setLoading(false);
          setValues((prevValues) => ({
            ...prevValues,
            customization: [],
            defaultCustomization: [],
          }));
        },
        () => setLoading(false)
      )
    );
  }

  const onSubmit = (values) => {
    dispatch(
      userModCreateAction(
        {
          role_id: values?.role_id,
          document_id: values?.document_id,
          customization: values?.customization,
        },
        onSubSuccess,
        onSubError
      )
    );
  };

  const onSubSuccess = (data) => {
    successToast(data?.message);
  };
  const onSubError = (data) => {
    errorToast(data?.message);
  };
  return (
    <InnerLayout title="Customization">
      <DndProvider backend={HTML5Backend}>
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {({ values, setFieldValue, setValues }) => {
            console.log(values, "sadfsdfdsfdsfdsfsdf");
            return (
              <Form className="h-full">
                <div className="flex justify-between w-full items-center h-[5rem] border-b border-b-[var(--top-nav-border-color)] px-[24px]">
                  <div className="min-w-[50%] flex gap-2 ">
                    <div className="min-w-[50%]">
                      <label className="">Profile</label>
                      <SelectField
                        handleSelected={(sel) => {
                          if (values?.document_id) {
                            fetchPermissions(
                              sel?.value,
                              values?.document_id,
                              setValues
                            );
                          }
                        }}
                        isDisabled={false}
                        placeholder={"Select"}
                        options={rolesList}
                        label={""}
                        id={"role_id"}
                        name="role_id"
                        isSearchable={true}
                        errMsgContainerClass="ps-2 hidden"
                      />
                    </div>
                    <div className="min-w-[50%]">
                      <label className="">Entry type</label>
                      <SelectField
                        handleSelected={(sel) => {
                          if (values?.role_id) {
                            fetchPermissions(
                              values?.role_id,
                              sel?.value,
                              setValues
                            );
                          }
                        }}
                        isDisabled={false}
                        placeholder={"Select"}
                        options={docList}
                        label={""}
                        id={"document_id"}
                        name="document_id"
                        isSearchable={true}
                        errMsgContainerClass="ps-2 hidden"
                      />
                    </div>
                  </div>
                  <div>
                    <AddButton
                      type="submit"
                      className="bg-primary text-white px-[12px] h-[32px] rounded-md flex justify-center items-center fw_500 text-sm whitespace-nowrap hover:bg-blue hover:text-white transition duration-300 ease-in-out gap-2 "
                      icon={<SaveIcon />}
                      prefixIcon={true}
                      text="Save Configuration"
                    />
                  </div>
                </div>
                <div className="h-[4rem] flex items-center justify-between px-[24px]">
                  <div className="flex gap-2 items-center">
                    <span className="px-2 rounded-full text-[var(--primary)] py-1  bg-opacity-5">
                      {values?.customization?.length} customization
                    </span>
                    <span>Drag to reorder customization</span>
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setValues({
                        ...values,
                        customization: values?.defaultCustomization,
                      });
                    }}
                    prefixIcon={false}
                    className="px-[12px] h-[32px] rounded-md flex justify-center items-center fw_500 text-sm whitespace-nowrap  transition duration-300 ease-in-out border-[var(--light-border-color)] border"
                    text="Reset to Default"
                  />
                </div>

                <div
                  style={{
                    height: `calc(100% - 9rem)`,
                  }}
                  className="flex flex-col justify-between  px-[24px]"
                >
                  {loading ? (
                    <LoadingSpinner />
                  ) : (
                    <div
                      style={{
                        height: `100%`,
                      }}
                      className="tab-container outline outline-[var(--list-table-border-color)] outline-1 border-radius"
                    >
                      <table className="w-full border-collapse mt-0">
                        <thead className="sticky top-0 bg-[var(--list-table-heading-bg)] z-[10]">
                          <tr className="relative">
                            {tableHeadings.map((heading, idx) => (
                              <th
                                key={idx}
                                className={`${"border-b border-[var(--list-table-border-color)] px-[8px]"} whitespace-nowrap text-[var(--list-table-heading-fg-color)]  text-[length:var(--list-table-heading-font-size)] font-[var(--list-table-heading-font-weight)] h-[50px]`}
                              >
                                <span className={`flex items-center gap-2 `}>
                                  {" "}
                                  {heading}
                                </span>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {values.customization?.map((col, idx) => (
                            <DraggableRow
                              key={col.id}
                              column={col}
                              index={idx}
                              values={values}
                              setFieldValue={setFieldValue}
                              tabletype="top"
                              dragType="COLUMN_TOP"
                            />
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </DndProvider>
    </InnerLayout>
  );
};

export default ColumnConfigForm;

const tableHeadings = [
  "Reorder",
  "Id",
  "Label",
  "Width",
  "Type",
  "Alignment",
  "enabled",
];
